import React from 'react';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ReferenceArea
} from 'recharts';
import { TICK_STYLE, TOOLTIP_WRAPPER_STYLE } from './constants';
import { RequestTooltip } from './tooltips';
import type { RequestDataPoint, ChartReferenceArea } from './types';

const RequestBarLabel: React.FC<unknown> = ({ x, y, width, value }) => {
  if (!value || value <= 0 || !Number.isFinite(value)) return null;
  const label = value >= 1000 ? `${(value / 1000).toFixed(1)}k` : String(value);
  return (
    <text x={x + width / 2} y={y - 4} textAnchor="middle" fontSize={12} fontWeight="bold" fill="#d1d5db">
      {label}
    </text>
  );
};

interface RequestTrendChartProps {
  data: RequestDataPoint[];
  showOverlays: boolean;
  referenceAreas: ChartReferenceArea[];
  formatTimestamp: (value: number | string) => string;
}

export const RequestTrendChart: React.FC<RequestTrendChartProps> = ({
  data,
  showOverlays,
  referenceAreas,
  formatTimestamp
}) => (
  <div className="p-2 sm:p-3" style={{ minHeight: '240px' }}>
    <ResponsiveContainer width="100%" height={220}>
      <BarChart data={data}>
        <CartesianGrid strokeDasharray="3 3" stroke="#374151" />
        {showOverlays && referenceAreas.map((area) => (
          <ReferenceArea
            key={`${area.type}-${area.start}`}
            x1={area.start}
            x2={area.end}
            fill={area.type === 'holiday' ? '#fbbf24' : '#9ca3af'}
            fillOpacity={0.2}
            stroke="none"
          />
        ))}
        <XAxis
          dataKey="timestamp"
          tick={TICK_STYLE}
          tickFormatter={formatTimestamp}
          stroke="#6b7280"
          interval="preserveEnd"
        />
        <YAxis
          tick={TICK_STYLE}
          stroke="#6b7280"
        />
        <Tooltip
          content={<RequestTooltip />}
          wrapperStyle={TOOLTIP_WRAPPER_STYLE}
        />
        <Legend />
        <Bar
          dataKey="requests"
          fill="#3b82f6"
          name="Requests"
          radius={[2, 2, 0, 0]}
          label={<RequestBarLabel />}
        />
      </BarChart>
    </ResponsiveContainer>
  </div>
);
